import { Pipe, PipeTransform } from "@angular/core";

const emailTemplate = {
    subject: "",
    body: "",
    to: ""
};

export interface EmailData {
    [key: string]: string | number;
}

export interface EmailTemplate {
    body: string;
    subject: string;
    to: string;
}

@Pipe({name: "deloitteaiBuildEmailLink"})
export class DeloitteAiBuildEmailLinkPipe implements PipeTransform {

    transform(value: EmailTemplate = emailTemplate, replacements: EmailData = {}): string {
        const subject = encodeURIComponent(this.replaceMarker(value.subject, replacements));
        const body    = encodeURIComponent(this.replaceMarker(value.body,    replacements));
        return `mailto:${value.to}?subject=${subject}&body=${body}`;
    }

    private replaceMarker(text: string, replacements: any): string {
        const pattern = /#{3}([^#]+)#{3}/g;
        return text.replace(pattern, (match, marker) => {
            const key = Object.keys(replacements).find(
                (replacement) => replacement === marker.toLowerCase()
            );
            return replacements[key] || match;
        });
    }
}
